import { createFileRoute } from '@tanstack/react-router'
import { IssuePage } from '../../../../components/IssuePage'

export const Route = createFileRoute('/$org/issues/$uid/edit')({
  component: IssueEdit,
})

function IssueEdit() {
  return <IssuePage />
}
